import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from 'features/core/shared/object/mvs-object-base/object-base.component';

/**
 * AI:
 * Status: "in progress"
 * Type: ObjectComponent
 * SubType: Configuration
 * Reason: Root object component of bd.DunningType — loads the dto and delegates to the full/side view
 *
 * Root ObjectBaseComponent for `bd.DunningType` — layer 1 of the three-layer OBC pattern
 * (root / view-base / view-full + view-side / shared).
 *
 * `bd.DunningType` is a COMPLEX configuration entity: it owns ten same-module configuration
 * children (levels, level actions, level transitions, starts, stops, charges, manual transactions,
 * one-time payments, termination reasons, pause reasons). The rule for that shape is a LEFT
 * NAVIGATION on the object page — which is why this component no longer carries a view switcher and
 * no longer carries a tab strip. Every view is a navigation point and therefore deep-linkable via
 * `?navItem=`; `bd-dunning-type-base.component.ts` declares the twelve of them.
 *
 * This class does exactly two things: it loads the dto (that is what `ObjectBaseComponent` is for)
 * and it forwards the left navigation its view component emits up to the page frame. The views
 * receive `dto` and `objectIdentifier` as bindings and build their own widgets, so there is nothing
 * left to rebuild here when the object changes.
 *
 * Reference implementation followed: `features/feature-prov/cp/component/object-components/
 * cp-provision-type-object/cp-provision-type-object.component.ts`.
 */
@Component({
    selector: 'dunning-type-object',
    templateUrl: './dunning-type-object.component.html',
    styleUrls: ['./dunning-type-object.component.scss'],
    standalone: false
})
export class DunningTypeObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    ngOnInit(): void {
        super.ngOnInit();
    }

    /**
     * The loaded object changed — publish its name as the page title and nothing else.
     *
     * `refreshObject()` must NEVER be called here: it would re-enter this very method and loop
     * forever. Clearing the left navigation must not happen here either — the view component
     * declares and emits it, and wiping it on every object change would race that emission and leave
     * the page frame without any navigation at all.
     */
    onObjectChanged(): void {
        // `storeNewDto()` also runs for an empty API body, so the dto can legitimately be falsy here.
        if (!this.dto) {
            return;
        }

        this.setPageTitle(this.dto['name']);
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

}
